import axios from "axios";
import {config} from "@/appconfig";
import {DienstleisterDienstleistungInfo, KonzerngesellschaftInfo, VTaetigkeit_info} from '@/Verarbeitungstaetigkeit/api-vtaetigkeit';
import { Auswahl, Auswahlliste } from '@/api';

const controller = 'drittlandtransferpruefung';

export interface Drittlandtransferpruefung_info {
    Id: number;
    Status: number;
    VerarbeitungstaetigkeitId: number;
    Verarbeitungstaetigkeit: string;
    Drittlaender: string[];    
    Lfd: number;
    _keywords: string;
    NaechstePruefung: string | null;
    IstAktiv: boolean;
}

export interface drittlandtransferpruefung_info_mit_vtaet extends Drittlandtransferpruefung_info {
    Verarbeitungstaetigkeit_info: VTaetigkeit_info | null;
}

export interface HistorienEintrag {
    Bearbeiter: string;
    Aenderung: string;
    GespeichertDatum: string;
    StatusAenderung: boolean;
}

export interface Drittlandtransferpruefung_base_info {
    Id: number;
    Status: number;
    VerarbeitungstaetigkeitId: number;
    Verarbeitungstaetigkeit: VTaetigkeit_info;
    IstAktiv: boolean;
}

export interface Drittlandtransferpruefung_Status_info extends Drittlandtransferpruefung_base_info {
    ModifiedName: string;
    ModifiedDate: string;
    ModifiedBydUserId: string | null;
    Historie: HistorienEintrag[];
}

export interface Neue_Drittlandtransferpruefung_form {
    Verfuegbare_Verarbeitungstaetigkeiten: number[];
}

export interface Neue_Drittlandtransferpruefung_command {
    Verarbeitungstaetigkeit: number;
}

export interface Neue_Drittlandtransferpruefung_result {
    Drittlandtransferpruefung: string;
}

export interface Drittlandtransferpruefung_statische_Daten {
    Dienstleister: DienstleisterDienstleistungInfo[];
    Konzerngesellschaften: KonzerngesellschaftInfo[];
    Rechtsgutachten: { LandKey: string, RechtsgutachtenDe: string | null, RechtsgutachtenEn: string | null }[];
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_datenuebermittlung {
    Eintraege: Auswahl[];
    Datenuebermittlung_alle: boolean;
    Datenuebermittlung_Kinder: boolean;
    Datenuebermittlung_Dauer_und_Komplexitaet: string;
    Datenuebermittlung_Angemessenheit: string;
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_uebermittlungsinstrumente {
    Eintraege: Auswahl[];
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_wirksamkeit {
    Wirksamkeit_Beurteilung: string;
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_massnahmen {
    Eintraege: Auswahl[];
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_verfahrensschritte {
    Gesamtabwaegung: string;
    Erforderlichkeit: boolean | null;    
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_neubewertung {
    DatumDerPruefung: string | null;
    WiedervorlageIntervall: number | null;
}

export interface Drittlandtransferpruefung_Dokumentationsangaben_dokumente {
    DokumentIds: number[];
}

export interface Drittlandtransferpruefung_Dokumentationsangaben
    extends Drittlandtransferpruefung_Dokumentationsangaben_datenuebermittlung
    , Drittlandtransferpruefung_Dokumentationsangaben_uebermittlungsinstrumente
    , Drittlandtransferpruefung_Dokumentationsangaben_wirksamkeit
    , Drittlandtransferpruefung_Dokumentationsangaben_massnahmen
    , Drittlandtransferpruefung_Dokumentationsangaben_verfahrensschritte
    , Drittlandtransferpruefung_Dokumentationsangaben_neubewertung
    , Drittlandtransferpruefung_Dokumentationsangaben_dokumente
{    
}

export interface Drittlandtransferpruefung_Angaben_info extends Drittlandtransferpruefung_base_info {
    Auswahllisten: Auswahlliste[];
    StatischeDaten: Drittlandtransferpruefung_statische_Daten;
    Angaben: Drittlandtransferpruefung_Dokumentationsangaben;
}

export class DrittlandtransferpruefungApi {
    public async Liste(): Promise<Drittlandtransferpruefung_info[]>{
        const response = await axios.get(`${config.apiUrl}/${controller}`, config.apiHeaders);
        return response.data;
    }

    public async Neue_Drittlandtransferpruefung_form(): Promise<Neue_Drittlandtransferpruefung_form>{
        const response = await axios.get(`${config.apiUrl}/${controller}/neu`, config.apiHeaders);
        return response.data;
    }

    public async Neue_Drittlandtransferpruefung(command: Neue_Drittlandtransferpruefung_command): Promise<Neue_Drittlandtransferpruefung_result>{
        const response = await axios.post(`${config.apiUrl}/${controller}/neu`, command, config.apiHeaders);
        return response.data;
    }

    public async Drittlandtransferpruefung_loeschen(id: number): Promise<void>{
        await axios.delete(`${config.apiUrl}/${controller}/${id}`, config.apiHeaders);
    }

    public async Name(id: number): Promise<string | null>{
        const response = await axios.get(`${config.apiUrl}/${controller}/${id}/name`, config.apiHeaders);
        return response.data || null;
    }

    public async Status(id: number): Promise<Drittlandtransferpruefung_Status_info | null>{
        const response = await axios.get(`${config.apiUrl}/${controller}/${id}/status`, config.apiHeaders);
        return response.data || null;
    }

    public async Status_aendern(id: number, status: number): Promise<Drittlandtransferpruefung_Status_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/status`, { Status: status }, config.apiHeaders);
        return response.data;
    }

    public async Angaben(id: number): Promise<Drittlandtransferpruefung_Angaben_info | null>{
        const response = await axios.get(`${config.apiUrl}/${controller}/${id}/angaben`, config.apiHeaders);
        return response.data || null;
    }

    public async Angaben_aendern_datenuebermittlung(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_datenuebermittlung): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_datenuebermittlung`, angaben, config.apiHeaders);
        return response.data;
    }

    public async Angaben_aendern_uebermittlungsinstrumente(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_uebermittlungsinstrumente): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_uebermittlungsinstrumente`, angaben, config.apiHeaders);
        return response.data;
    }

    public async Angaben_aendern_wirksamkeit(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_wirksamkeit): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_wirksamkeit`, angaben, config.apiHeaders);
        return response.data;
    }

    public async Angaben_aendern_massnahmen(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_massnahmen): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_massnahmen`, angaben, config.apiHeaders);
        return response.data;
    }
    
    public async Angaben_aendern_verfahrensschritte(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_verfahrensschritte): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_verfahrensschritte`, angaben, config.apiHeaders);
        return response.data;
    }

    public async Angaben_aendern_neubewertung(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_neubewertung): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_neubewertung`, angaben, config.apiHeaders);
        return response.data;
    }

    public async Angaben_aendern_dokumente(id: number, angaben: Drittlandtransferpruefung_Dokumentationsangaben_dokumente): Promise<Drittlandtransferpruefung_Angaben_info> {
        const response = await axios.put(`${config.apiUrl}/${controller}/${id}/angaben_dokumente`, angaben, config.apiHeaders);
        return response.data;
    }
}
